/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Kol.css';
import ReactEcharts from 'echarts-for-react'





class Kol extends React.Component {

    constructor(props){
        super(props)
        this.state={}
        this.getOption=this.getOption.bind(this)
    }

    getOption=()=>{
        // console.log(this.props.json)
        // var num_array = [30, 30, 50, 40, 60, 40, 40, 40, 40, 70, 30];
        var num_array=this.props.json

        // var num_array=[0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0]
        
                
        function calculate(num_array) {
            let result_array = []
            let wb_num = num_array[0] + num_array[1] + num_array[2] + num_array[3]
            let wx_num = num_array[4] + num_array[5]
            let tt_num = num_array[6] + num_array[7]
            let zh_num = num_array[8] + num_array[9] + num_array[10]
            var base_num = wb_num
            if (wx_num > base_num) {
                base_num = wx_num
            }
            if (tt_num > base_num) {
                base_num = tt_num
            }
            if (zh_num > base_num) {
                base_num = zh_num
            }
            let wb_rate = Math.sqrt(parseFloat(wb_num) / parseFloat(base_num))
            let wx_rate = Math.sqrt(parseFloat(wx_num) / parseFloat(base_num))
            let tt_rate = Math.sqrt(parseFloat(tt_num) / parseFloat(base_num))
            let zh_rate = Math.sqrt(parseFloat(zh_num) / parseFloat(base_num))
            result_array[0] = num_array[0]==0?0:Math.sqrt(parseFloat(num_array[0]) / wb_num) * wb_rate * 100
            result_array[1] = num_array[1]==0?0:Math.sqrt(parseFloat(num_array[0] + num_array[1]) / wb_num) * wb_rate * 100
            result_array[2] = num_array[2]==0?0:Math.sqrt(parseFloat(num_array[0] + num_array[1] + num_array[2]) / wb_num) * wb_rate * 100
            result_array[3] = num_array[3]==0?0:100 * wb_rate
            result_array[4] = num_array[4]==0?0:Math.sqrt(parseFloat(num_array[4]) / wx_num) * wx_rate * 100
            result_array[5] = num_array[5]==0?0:100 * wx_rate
            result_array[6] = num_array[6]==0?0:Math.sqrt(parseFloat(num_array[6]) / tt_num) * tt_rate * 100
            result_array[7] = num_array[7]==0?0:100 * tt_rate
            result_array[8] = num_array[8]==0?0:Math.sqrt(parseFloat(num_array[8]) / zh_num) * zh_rate * 100
            result_array[9] = num_array[9]==0?0:Math.sqrt(parseFloat(num_array[8] + num_array[9]) / zh_num) * zh_rate * 100
            result_array[10] = num_array[10]==0?0:100 * zh_rate
            
            // console.log(num_array[2],result_array[2])

            result_array[11] = (parseFloat(num_array[0]) / wb_num * 100).toFixed(2)
            result_array[12] = (parseFloat(num_array[1]) / wb_num * 100).toFixed(2)
            result_array[13] = (parseFloat(num_array[2]) / wb_num * 100).toFixed(2)
            result_array[14] = (parseFloat(num_array[3]) / wb_num * 100).toFixed(2)
            result_array[15] = (parseFloat(num_array[4]) / wx_num * 100).toFixed(2)
            result_array[16] = (parseFloat(num_array[5]) / wx_num * 100).toFixed(2)
            result_array[17] = (parseFloat(num_array[6]) / tt_num * 100).toFixed(2)
            result_array[18] = (parseFloat(num_array[7]) / tt_num * 100).toFixed(2)
            result_array[19] = (parseFloat(num_array[8]) / zh_num * 100).toFixed(2)
            result_array[20] = (parseFloat(num_array[9]) / zh_num * 100).toFixed(2)
            result_array[21] = (parseFloat(num_array[10]) / zh_num * 100).toFixed(2)
            
            return result_array
        }
        let result_array = calculate(num_array)
        var data = {
            name: ['微博金V认证', '微博橙V认证', '微博蓝V认证', '微博一般用户', '微信认证账号','微信非认证账号', '今日头条认证账号', '今日头条非认证账号', '知乎优秀回答者', '知乎认证回答者', '知乎一般用户'],

        };
        var data2 = [
                { 'name': '微博金V认证', 'radius': result_array[0] + '%', 'value': [result_array[11], 0, 0, 0] },
                { 'name': '微博橙V认证', 'radius': result_array[1] + '%', 'value': [result_array[12], 0, 0, 0] },
                { 'name': '微博蓝V认证', 'radius': result_array[2] + '%', 'value': [result_array[13], 0, 0, 0] },
                { 'name': '微博一般用户', 'radius': result_array[3] + '%', 'value': [result_array[14], 0, 0, 0] },
                { 'name': '微信认证账号', 'radius': result_array[4] + '%', 'value': [result_array[15], 0, 0, 0] },
                { 'name': '微信非认证账号', 'radius': result_array[5] + '%', 'value': [result_array[16], 0, 0, 0] },
                { 'name': '今日头条认证账号', 'radius': result_array[6] + '%', 'value': [result_array[17], 0, 0, 0] },
                { 'name': '今日头条非认证账号', 'radius': result_array[7] + '%', 'value': [result_array[18], 0, 0, 0] },
                { 'name': '知乎优秀回答者', 'radius': result_array[8] + '%', 'value': [result_array[19], 0, 0, 0] },
                { 'name': '知乎认证回答者', 'radius': result_array[9] + '%', 'value': [result_array[20], 0, 0, 0] },
                { 'name': '知乎一般用户', 'radius': result_array[10] + '%', 'value': [result_array[21], 0, 0, 0] }
                

            ]
            // console.log(data2)
        var option = {
            // color:['#fabe95','#fac19c','#fcedcd','#a5d9a6','#dbeedf','#f1b1ad','#f7d2d1','#4fb7ed','#99d3f1','#c8e7f4'，'#fac19c'],
            title: {
                text: `KOL参与图 -${this.props.items.name} `,
                subtext: '数据来源：数字品牌榜',
                x: '20'
            },
            tooltip: {
                trigger: 'item',
                // formatter: "{a} <br/>{b}: {c} ({d}%)",
                formatter: function(params, data) {
                    // console.log(data,params)
                    return params.seriesName + '<br/>' + params.data + '%';

                }
            },
            toolbox: {
                show: true,
                feature: {
                    restore: {},
                    saveAsImage: {}
                },
                right: 20
            },
            legend: {
                selectedMode: false,
                orient: 'vertical',
                right: 10,
                bottom: 10,
                data: data.name,
            },
            series: [{
                    name: data2[0].name,
                    type: 'pie',
                    radius: [0, data2[0].radius],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    startAngle: 180,
                    zlevel: 4,
                    label: {
                        normal: {
                            show: false,
                        },
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#fa8b5a',
                            borderWidth: 1,
                            //   borderColor:'#000'
                        }
                    },
                    data: (function(){
                        // console.log(data2[0].value)
                        
                            if(data2[0].value.length>4){
                                data2[0].value.length=4
                            }
                            // console.log(data2[0].value)
                            
                        return  data2[0].value
                    
                    })(),
                    // tooltip:{
                    //     trigger: 'item',
                    //     formatter:function(params,data,data2){
                    //             console.log(params,data,data2)
                    //             return 
                    //         },
                    // }
                },
                {
                    name: data2[1].name,
                    type: 'pie',
                    radius: [0, data2[1].radius],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    startAngle: 180,
                    zlevel: 3,
                    label: {
                        normal: {
                            show: false
                        },
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#f8aa76',
                            borderWidth: 1,
                            //   borderColor:'#000'
                        }
                    },
                    data: data2[1].value
                }, {
                    name: data2[2].name,
                    type: 'pie',
                    radius: [0, data2[2].radius],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    startAngle: 180,
                    zlevel: 2,
                    label: {
                        normal: {
                            show: false
                        },
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#fac19c',
                            borderWidth: 1,
                            //   borderColor:'#000'
                        }
                    },
                    data: data2[2].value
                },
                {
                    name: data2[3].name,
                    type: 'pie',
                    radius: [0, data2[3].radius],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    startAngle: 180,
                    zlevel: 1,
                    label: {
                        normal: {
                            show: false
                        },
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#fce0cd',
                            borderWidth: 1,
                            //   borderColor:'#000'
                        }
                    },
                    data: data2[3].value
                },
                {
                    name: data2[4].name,
                    type: 'pie',
                    radius: [0, data2[4].radius],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    startAngle: 90,
                    zlevel: 3,
                    label: {
                        normal: {
                            show: false
                        },
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#b0d9b8',
                            borderWidth: 1,
                            //   borderColor:'#000'
                        }
                    },
                    data: data2[4].value
                },
                {
                    name: data2[5].name,
                    type: 'pie',
                    radius: [0, data2[5].radius],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    startAngle: 90,
                    zlevel: 2,
                    label: {
                        normal: {
                            show: false
                        },
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#dbeedf',
                            //   borderWidth:1,
                            //   borderColor:'#000'
                        }
                    },
                    data: data2[5].value
                }, {
                    name: data2[6].name,
                    type: 'pie',
                    radius: [0, data2[6].radius],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    startAngle: 0,
                    zlevel: 3,
                    label: {
                        normal: {
                            show: false
                        },
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#ee9c99',
                            borderWidth: 1,
                            //   borderColor:'#000'
                        }
                    },
                    data: data2[6].value
                },
                {
                    name: data2[7].name,
                    type: 'pie',
                    radius: [0, data2[7].radius],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    startAngle: 0,
                    zlevel: 2,
                    label: {
                        normal: {
                            show: false
                        },
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#f7d2d1',
                            borderWidth: 1,
                            //   borderColor:'#000'
                        }
                    },
                    data: data2[7].value
                },
                {
                    name: data2[8].name,
                    type: 'pie',
                    radius: [0, data2[8].radius],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    startAngle: 270,
                    zlevel: 3,
                    label: {
                        normal: {
                            show: false
                        },
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#4fb7ed',
                            borderWidth: 1,
                            //   borderColor:'#000'
                        }
                    },
                    data: data2[8].value
                }, {
                    name: data2[9].name,
                    type: 'pie',
                    radius: [0, data2[9].radius],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    startAngle: 270,
                    zlevel: 2,
                    label: {
                        normal: {
                            show: false
                        },
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#99d6f5',
                            //   borderColor:'#000',
                            borderWidth: 1
                        }
                    },
                    data: data2[9].value
                }, {
                    name: data2[10].name,
                    type: 'pie',
                    radius: [0, data2[10].radius],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    startAngle: 270,
                    zlevel: 1,
                    label: {
                        normal: {
                            show: false
                        },
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#caeafa',
                            //   borderColor:'#000',
                            borderWidth: 1
                        }
                    },
                    data: data2[10].value
                }
            ]
        }
        return option
    }
    render() {
        return (

            <ReactEcharts option = { this.getOption() }
            style = {{
                    height: '550px',
                    width:'100%',
                    
                    borderRadius: '4px'}}
            className = { s.charts }
            notMerge = { true }
            lazyUpdate = { true }
            theme = { "theme_name" }
            onChartReady = { this.onChartReadyCallback }
            />
        )




    }
}

export default withStyles(s)(Kol);


// WEBPACK FOOTER //
// src/components/Kol/Kol.js